<template>
  <Loading :loading="loading" class="orders">
    <div class="row">
      <h2 class="col-12 mb-3">My Purchases</h2>
      <div v-if="purchases && purchases.length > 0" class="col-12 col-lg-10">
        <OrderItem v-for="purchase in purchases" :key="purchase.id" :item="purchase"/>
      </div>
      <div v-else class="text-center col-12 col-md-5">
        You haven't purchased anything yet!
        <br>
        <router-link :to="{name:'shop'}" class="btn btn-primary">Shop Now</router-link>
      </div>
    </div>
  </Loading>
</template>

<script>
import { fetchPurchases } from "@/network/purchasesRequests";

import Loading from "@/components/loading/Loading";
import OrderItem from "./OrderItem";

export default {
  name: "Purchases",
  components: {
    Loading,
    OrderItem
  },
  data() {
    return {
      purchases: null,
      loading: false
    };
  },
  created() {
    this.loading = true;
    fetchPurchases(purchases => {
      this.purchases = purchases;
      this.loading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
</style>
